import React, { useState, memo } from "react";
import SideMenu from "../../components/SideMenu";
import IuguOnboardingService from "../../services/IuguOnboardingService";

const Input = memo(function Input({ label, name, type = "text", value, onChange, ...rest }) {
  return (
    <label style={{ display: "grid", gap: 6 }}>
      <span style={{ fontSize: 13, color: "#667085" }}>{label}</span>
      <input
        name={name}
        type={type}
        value={value ?? ""}
        onChange={(ev) => onChange(name, ev.target.value)}
        className="input"
        {...rest}
      />
    </label>
  );
});

const FileInput = memo(function FileInput({ label, name, accept, onFile }) {
  return (
    <label style={{ display: "grid", gap: 6 }}>
      <span style={{ fontSize: 13, color: "#667085" }}>{label}</span>
      <input
        name={name}
        type="file"
        accept={accept}
        onChange={(ev) => onFile(name, ev.target.files?.[0] || null)}
      />
    </label>
  );
});

const Styles = memo(function Styles() {
  return (
    <style>{`
      .card { background:#fff; border:1px solid #e5e7eb; border-radius:16px; padding:18px; box-shadow:0 6px 18px rgba(16,24,40,.08); }
      .grid2 { display:grid; grid-template-columns: 1fr 1fr; gap:14px; }
      @media (max-width: 900px){ .grid2{ grid-template-columns:1fr; } }
      .actions { display:flex; gap:12px; justify-content:flex-end; margin-top:16px; }
      .btn { border:1px solid #e5e7eb; background:#fff; border-radius:10px; padding:10px 14px; cursor:pointer; }
      .btn--primary { background:#1c787e; color:#0a0a0a; font-weight:700; border-color:transparent; }
      .input { background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:10px 12px; }
    `}</style>
  );
});

export default function IuguOnboarding() {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState({
    socialContract: null,
    proofAddress: null,
    documentRepresentative: null,
    selfieRepresentative: null,
  });

  const [form, setForm] = useState({
    email: "",
    password: "",
    name: "",
    doc: "",
    companyType: "",
    city: "",
    neighborhood: "",
    number: "",
    postalCode: "",
    state: "",
    street: "",
    tradingName: "",
    businessName: "",
    contactNumber: "",
    balance: "",
  });

  const onChange = (k, v) => setForm((s) => ({ ...s, [k]: v }));
  const onFile = (k, file) => setFiles((s) => ({ ...s, [k]: file }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await IuguOnboardingService.create({
        ...form,
        socialContract: files.socialContract,
        proofAddress: files.proofAddress,
        documentRepresentative: files.documentRepresentative,
        selfieRepresentative: files.selfieRepresentative,
      });
      alert("Cadastro enviado com sucesso!");
      setForm({
        email: "",
        password: "",
        name: "",
        doc: "",
        companyType: "",
        city: "",
        neighborhood: "",
        number: "",
        postalCode: "",
        state: "",
        street: "",
        tradingName: "",
        businessName: "",
        contactNumber: "",
        balance: "",
      });
      setFiles({
        socialContract: null,
        proofAddress: null,
        documentRepresentative: null,
        selfieRepresentative: null,
      });
      e.target.reset();
    } catch (err) {
      console.error(err);
      alert("Falha ao enviar cadastro. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="userPage" className="userPage transactionPage">
      <SideMenu />
      <div className="contentData">
        <div className="contentScroll">
          <div className="ramps">
            <Styles />

            <p className="breadcrumb">
              <b><span style={{ color: "#1c787e" }}>Início</span> | Enviar cadastro para Iugu</b>
            </p>
            <br />
            <p className="title"><span style={{ fontWeight: "normal" }}>Iugu |</span> Cadastro</p>
            <br />

            <section className="card">
              <form onSubmit={onSubmit} style={{ display: "grid", gap: 16 }}>
                <div className="grid2">
                  <Input label="Email" name="email" type="email" required value={form.email} onChange={onChange} />
                  <Input label="Nome" name="name" required value={form.name} onChange={onChange} />
                  <Input label="Documento (CPF/CNPJ)" name="doc" required value={form.doc} onChange={onChange} />
                  <Input label="Tipo de empresa" name="companyType" required value={form.companyType} onChange={onChange} />
                  <Input label="Telefone de contato" name="contactNumber" value={form.contactNumber} onChange={onChange} />
                  <Input label="Nome fantasia" name="tradingName" value={form.tradingName} onChange={onChange} />
                  <Input label="Razão social" name="businessName" value={form.businessName} onChange={onChange} />
                </div>

                <hr />

                <div className="grid2">
                  <Input label="Estado" name="state" value={form.state} onChange={onChange} />
                  <Input label="Cidade" name="city" value={form.city} onChange={onChange} />
                  <Input label="Bairro" name="neighborhood" value={form.neighborhood} onChange={onChange} />
                  <Input label="Rua" name="street" value={form.street} onChange={onChange} />
                  <Input label="Número" name="number" value={form.number} onChange={onChange} />
                  <Input label="CEP" name="postalCode" value={form.postalCode} onChange={onChange} />
                </div>

                <hr />

                <div className="grid2">
                  <FileInput label="Contrato social (PDF/IMG)" name="socialContract" accept=".pdf,image/*" onFile={onFile} />
                  <FileInput label="Comprovante de endereço (PDF/IMG)" name="proofAddress" accept=".pdf,image/*" onFile={onFile} />
                  <FileInput label="Documento representante (PDF/IMG)" name="documentRepresentative" accept=".pdf,image/*" onFile={onFile} />
                  <FileInput label="Selfie representante (IMG)" name="selfieRepresentative" accept="image/*" onFile={onFile} />
                </div>

                <div className="actions">
                  <button type="button" className="btn" onClick={() => window.history.back()}>
                    Voltar
                  </button>
                  <button type="submit" className="btn btn--primary" disabled={loading}>
                    {loading ? "Enviando…" : "Enviar cadastro para Iugu"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
}


